import { FetchWithAuth } from '../auth';
import env from '../configs/env';

export interface FileUploadParams {
  cedant: string;
  fileName: string;
  contentType: string;
  file: File;
}

export class FileUploadService {
  static async uploadFile(
    params: FileUploadParams,
    token: string,
    fetchWithAuth: FetchWithAuth,
  ): Promise<void> {
    const { cedant, fileName, contentType, file } = params;
    
    const formData = new FormData();
    formData.append('cedant', cedant);
    formData.append('fileName', fileName);
    formData.append('contentType', contentType);
    formData.append('file', file);

    const response = await fetchWithAuth(`${env.api.host}${env.api.paths.fileUpload}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      body: formData,
    });

    if (!response.ok) {
      if (response.status === 401 || response.status === 403) {
        throw new Error('TOKEN_EXPIRED');
      }
      throw new Error(`Upload failed: ${response.status} ${response.statusText}`);
    }
  }
}